export const LIST_PREVIEW_SUBSCREEN_KEYS = {
  MAP: 'map',
  LIST: 'list',
} as const

export type ListPreviewSubscreenKey = typeof LIST_PREVIEW_SUBSCREEN_KEYS[keyof typeof LIST_PREVIEW_SUBSCREEN_KEYS]
